import * as REMINDER from '../constants/reminder';


export default {
  [REMINDER.MUTATE_LIST_REMINDER]: (state, data) => {
    state.list = data;
  }
}


// WEBPACK FOOTER //
// ./src/store/reminder/mutations.js